(function () {
  var ROOT_VAR = '--ghost-announcement-height';
  var OFFSET_VAR = '--ghost-header-offset';
  var BASE_OFFSET = 'calc(4px + 5rem)';

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* ignore */
    }
  }

  function removeStorage(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      /* ignore */
    }
  }

  function formatHours(value) {
    return value < 10 ? String(value).padStart(2, '0') : String(value);
  }

  function formatUnit(value) {
    return String(value).padStart(2, '0');
  }

  function parseStartTime(bar) {
    var raw = bar.dataset.startDatetime;
    if (!raw) return null;

    var parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function parseEndTime(bar) {
    var mode = bar.dataset.countdownMode;
    var storageKey = bar.dataset.storageKey;

    if (mode === 'duration') {
      var hours = Number(bar.dataset.durationHours || 36);
      var endKey = storageKey + '-end';
      var stored = readStorage(endKey);
      var endTime = stored ? Number(stored) : NaN;

      if (!stored || Number.isNaN(endTime) || endTime <= Date.now()) {
        endTime = Date.now() + hours * 60 * 60 * 1000;
        writeStorage(endKey, String(endTime));
      }

      return endTime;
    }

    var raw = bar.dataset.endDatetime;
    if (!raw) return null;

    var parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function getTimeLeft(endTime) {
    if (!endTime) {
      return { hours: '00', minutes: '00', seconds: '00', done: false };
    }

    var diff = endTime - Date.now();
    if (diff <= 0) {
      return { hours: '00', minutes: '00', seconds: '00', done: true };
    }

    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return {
      hours: formatHours(hours),
      minutes: formatUnit(minutes),
      seconds: formatUnit(seconds),
      done: false
    };
  }

  function setCountdownValues(bar, time) {
    bar.querySelectorAll('[data-ghost-countdown-hours]').forEach(function (node) {
      node.textContent = time.hours;
    });
    bar.querySelectorAll('[data-ghost-countdown-minutes]').forEach(function (node) {
      node.textContent = time.minutes;
    });
    bar.querySelectorAll('[data-ghost-countdown-seconds]').forEach(function (node) {
      node.textContent = time.seconds;
    });
  }

  function updateLayoutHeight(bar) {
    var root = document.documentElement;
    var visible = bar && !bar.hidden && !bar.classList.contains('is-hidden');
    var height = visible ? bar.offsetHeight + 'px' : '0px';

    root.style.setProperty(ROOT_VAR, height);
    root.style.setProperty(OFFSET_VAR, 'calc(' + height + ' + ' + BASE_OFFSET + ')');
  }

  function hideBar(bar) {
    bar.hidden = true;
    bar.classList.add('is-hidden');
    updateLayoutHeight(bar);
  }

  function showBar(bar) {
    bar.hidden = false;
    bar.classList.remove('is-hidden');
    updateLayoutHeight(bar);
  }

  function initBar(bar) {
    var storageKey = bar.dataset.storageKey;
    var dismissKey = storageKey + '-dismissed';
    var hideWhenExpired = bar.dataset.hideWhenExpired === 'true';
    var dismissible = bar.dataset.dismissible === 'true';
    var startTime = parseStartTime(bar);
    var endTime = parseEndTime(bar);
    var timerId = null;
    var startTimerId = null;

    function beginBar() {
      if (dismissible && readStorage(dismissKey) === '1') {
        hideBar(bar);
        return;
      }

      function refreshCountdown() {
        var time = getTimeLeft(endTime);
        setCountdownValues(bar, time);

        if (time.done && hideWhenExpired) {
          if (timerId) window.clearInterval(timerId);
          removeStorage(storageKey + '-end');
          hideBar(bar);
        }
      }

      showBar(bar);

      if (bar.querySelector('[data-ghost-countdown-hours]')) {
        refreshCountdown();
        timerId = window.setInterval(refreshCountdown, 1000);
      }

      var dismissButton = bar.querySelector('[data-ghost-announcement-dismiss]');
      if (dismissButton) {
        dismissButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          writeStorage(dismissKey, '1');
          if (timerId) window.clearInterval(timerId);
          hideBar(bar);
        });
      }

      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(function () {
          updateLayoutHeight(bar);
        });
        observer.observe(bar);
      }

      window.addEventListener('resize', function () {
        updateLayoutHeight(bar);
      });

      updateLayoutHeight(bar);
    }

    if (endTime && hideWhenExpired && Date.now() >= endTime) {
      hideBar(bar);
      return;
    }

    if (startTime && Date.now() < startTime) {
      hideBar(bar);
      startTimerId = window.setInterval(function () {
        if (Date.now() >= startTime) {
          window.clearInterval(startTimerId);
          beginBar();
        }
      }, 1000);
      return;
    }

    beginBar();
  }

  function init() {
    document.querySelectorAll('[data-ghost-announcement-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('[data-ghost-announcement-bar]');
    if (bar) initBar(bar);
  });
})();
